module.exports = __webpack_public_path__ + "assets/img/workpiece.c1924d63.png";